import { Action, ApiState, ApiStateBase } from "../misc/api.types";

export const callService = <T, U>(
  state: ApiState<T, U>,
  updates?: Partial<U>,
  setFilter?: (f: U) => void
): ApiState<T, U> => {
  const filter = updates ? { ...state.filter, ...updates } : state.filter;
  if (setFilter) setFilter(filter);
  return { data: state.data, filter, trigger: !state.trigger, loading: true };
};

export const serviceReducerBase = <T>(state: ApiStateBase<T>, action: Action<T>): ApiStateBase<T> => {
  switch (action.type) {
    case "INIT":
      return { ...state, loading: true };
    case "SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "FAIL":
      return { ...state, loading: false, data: null };
    case "RELOAD":
      return { ...state, trigger: !state.trigger };
    default:
      return state;
  }
};

export const serviceReducer = <T, U>(state: ApiState<T, U>, action: Action<T>): ApiState<T, U> => {
  switch (action.type) {
    case "INIT":
      return { ...state, loading: true };
    case "SUCCESS":
      return { ...state, loading: false, data: action.payload };
    case "FAIL":
      return { ...state, loading: false, data: null };
    case "LOADER":
      return { ...state, loading: action.value };
    case "RELOAD":
      return callService(state);
    default:
      return state;
  }
};
